var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Icons")]),_c('div',{staticStyle:{"display":"flex","flex-flow":"row wrap","color":"#444"}},_vm._l((_vm.sorted),function(i){return _c('div',{staticStyle:{"width":"6rem","margin":"1rem"}},[_c('icon',{staticClass:"big",attrs:{"name":i}}),_c('div',{staticClass:"name"},[_vm._v(_vm._s(i))])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }